export default "__VITE_ASSET__48lU4E5S__"